import { render, staticRenderFns } from "./TrafficRequestNewTermsTemplate.vue?vue&type=template&id=d13b2c1e&scoped=true"
import script from "./TrafficRequestNewTermsTemplate.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestNewTermsTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b2c1e",
  null
  
)

export default component.exports